import { gsap, ScrollTrigger } from '@gsap';

/**
 * Layout: Content - Afbeelding Grid
 * Slug: content_afbeelding_grid
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.content_afbeelding_grid-layout');

	layouts.forEach((layout) => {
		gsap.registerPlugin(ScrollTrigger);

		gsap.from(layout.querySelectorAll(".image-grid-container img"), {
			scale: 0.5,
			stagger: 0.1,
			scrollTrigger: {
				trigger: layout.querySelector(".image-grid-container"),
				scrub: 2,
				start: "top bottom",
				end: "bottom-=25% bottom",
				markers: false
			}
		});
	});
});
